export default function (value: any ){
    if(!value || !value.nombre || !value.apellidos) return;
    const nombre = value.nombre[0];
    const apellidos = value.apellidos[0];
    return nombre+apellidos;
}